import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from './components';
import Stack from '@mui/material/Stack';
import LoginForm from './main';
import NewAccount from './new-account';
import ExistingAccount from './existing-account';
const LoginLayout = () => {
    return (_jsx(Container, Object.assign({ className: 'image-cover cover-loaded bg', sx: {
            backgroundImage: 'url("//stenbolagetproffs.se/cdn/shop/files/Cam_08_30xVar.0002_43.jpg?format=pjpg&v=1704279467&width=1400")',
        } }, { children: _jsxs(Stack, Object.assign({ spacing: 2, justifyContent: 'center', alignItems: 'center', sx: {
                width: '100%',
            } }, { children: [_jsx(LoginForm, {}), _jsx(NewAccount, {}), _jsx(ExistingAccount, {})] })) })));
};
export default LoginLayout;
